import React from "react"
import ShelterArea from "../ShelterArea"
import { PCViewRoot } from "../Common/PCViewContext"

const ShelterAreaPage = (props) => {
  return (
    <PCViewRoot>
      <ShelterArea {...props} />
    </PCViewRoot>
  )
}
export default ShelterAreaPage
